module.exports = __webpack_public_path__ + "img/Butterfly_00018.33309b30.png";